import axios from 'axios';
import config from './Config';
import {IS_LOADING, SNACKBAR_OPEN} from '../reducers';

axios.defaults.baseURL = config.API_URL;
axios.defaults.timeout = 0;

export const PlainApiUtils = {
  axios: axios.create({baseURL: config.API_URL, timeout: 0}),
  dispatch: null,
  state: null,
};

const changeLoaderStatus = () => {
  PlainApiUtils.dispatch({type: IS_LOADING, payload: {isLoad: false}});
  PlainApiUtils.dispatch({type: 'IS_NOT_LOADING', payload: true});
};

// The API renders every non-2xx body as {"error": "..."} (see
// museum_api/libs/renderer.py), so read `error` first and keep `message` only
// as a fallback for anything that does not go through that renderer.
const errorMessage = (error) =>
  error?.response?.data?.error ||
  error?.response?.data?.message ||
  error?.response?.data?.errors?.join(', ');

// Add a request interceptor
PlainApiUtils.axios.interceptors.request.use(function (config) {
  PlainApiUtils.dispatch({type: IS_LOADING, payload: {isLoad: PlainApiUtils.state.loaderState}});
  return config;
}, function (error) {
  changeLoaderStatus();
  if (!error.response) {
    PlainApiUtils.dispatch({type: SNACKBAR_OPEN, payload: {isNotify: true, severity: 'error', message: error.message}});
    return Promise.reject(new Error(error.message || 'Request failed'));
  }
  const message = errorMessage(error);
  // Do something with request error
  PlainApiUtils.dispatch({type: SNACKBAR_OPEN, payload: {isNotify: true, severity: 'error', message: message}});
  return Promise.reject(new Error(message || 'Request failed'));
});

PlainApiUtils.axios.interceptors.response.use(function (response) {
  changeLoaderStatus();
  return response;
}, function (error) {
  changeLoaderStatus();
  if (!error.response) {
    PlainApiUtils.dispatch({type: SNACKBAR_OPEN, payload: {isNotify: true, severity: 'error', message: error.message}});
    return Promise.reject(new Error(error.message || 'Request failed'));
  }
  if (401 === error.response.status) {
    // Deliberately NOT clearing storage here. This client never attaches an
    // Authorization header, so a 401 on one of its requests says nothing about
    // the token in storage -- and clearing it used to destroy a token that a
    // concurrent login had just written.
    /* eslint-disable-next-line no-console */
    console.warn(
      `[auth] 401 on anonymous request ${String(error.config?.method || '?').toUpperCase()} ` +
      `${error.config?.url || '?'} -- session left intact`
    );
  }
  const message = errorMessage(error);
  PlainApiUtils.dispatch({type: SNACKBAR_OPEN, payload: {isNotify: true, severity: 'error', message: message}});
  return Promise.reject(new Error(message || 'Request failed'));
});

export default (url, method, params, data, responseType) => PlainApiUtils.axios.request({
  url,
  method,
  params,
  data,
  responseType
});
